var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3958 92.6154L98.7404 55.2708L95.2853 51.8493L61.3958 85.8509L44.3446 68.7996L41.0352 72.2212L61.3958 92.6154ZM70.0195 122.5C62.7821 122.5 55.9866 121.122 49.6329 118.367C43.2792 115.612 37.7141 111.848 32.9378 107.077C28.1615 102.305 24.3945 96.7449 21.6367 90.3971C18.8789 84.0494 17.5 77.2569 17.5 70.0195C17.5 62.7597 18.8776 55.9342 21.6328 49.5431C24.388 43.152 28.1516 37.5926 32.9235 32.8649C37.6953 28.1372 43.2551 24.3945 49.6029 21.6367C55.9506 18.8789 62.7431 17.5 69.9805 17.5C77.2403 17.5 84.0658 18.8776 90.4569 21.6328C96.848 24.388 102.407 28.1273 107.135 32.8506C111.863 37.5738 115.605 43.128 118.363 49.513C121.121 55.8982 122.5 62.7207 122.5 69.9805C122.5 77.2179 121.122 84.0134 118.367 90.3671C115.612 96.7208 111.873 102.286 107.149 107.062C102.426 111.838 96.872 115.605 90.487 118.363C84.1018 121.121 77.2793 122.5 70.0195 122.5Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.73d5063f61c05d5f03489eb7e36ab4d5.svg";
export { ForwardRef as ReactComponent };